import { Component } from '@angular/core';

@Component({
  selector: 'app-workshop-buttons24',
  templateUrl: './workshop-buttons24.component.html',
  styleUrl: './workshop-buttons24.component.css'
})
export class WorkshopButtons24Component {

}
